import React, { useState, useEffect, useRef } from 'react'
import { nanoid } from "nanoid"
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom"
import { toast, Toaster } from 'sonner';
import { BiLoader } from "react-icons/bi"
import api from '../../controller/api';

export default function ProductAdd() {
    const [category, setCategory] = useState([])

    const [categoryId, setCategoryId] = useState("");
    const [title, setTitle] = useState("");
    const [file, setFile] = useState("")
    const [price, setPrice] = useState()
    const [discount, setDiscount] = useState()
    const [timing, setTiming] = useState()
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()
    const inputFile = useRef(null);

    const clearInput = () => {
        setCategoryId("")
        setTitle("")
        setPrice()
        setDiscount()
        setTiming()
        inputFile.current.value = "";
    };

    const handleAddProduct = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const formData = new FormData()
            formData.append("file", file);
            formData.append("categoryId", categoryId);
            formData.append("title", title);
            formData.append("price", price);
            formData.append("discount", discount);
            formData.append("timing", timing);

            const { data: res } = await api.post("/product/create", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            toast.success("Product added")
            clearInput()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const fetchCategory = async () => {
        try {
            const { data: res } = await api.get("/category/list")
            setCategory(res.data)
        } catch (error) {
            console.error(error?.response?.data?.message);
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        }
    }

    const categoryList = category.map((category) => <option key={category._id} value={category._id}>{category.categoryName}</option>)

    useEffect(() => {
        fetchCategory()

    }, [])
    return (
        <div className='manage'>
            <Toaster richColors position="top-center" />
            <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                Add Product
                <Button variant="contained" onClick={() => navigate("/dashboard/products")}>Back to List</Button>
            </h2>
            <div className='add-product'>
                <form onSubmit={handleAddProduct}>
                    <div className='form-row'>
                        <div className='inpt-row'>
                            <label>Title</label>
                            <input type='text' value={title} onChange={(e) => setTitle(e.target.value)} required />
                        </div>
                        <div className='inpt-row'>
                            <label>Price</label>
                            <input type='number' value={price} onChange={(e) => setPrice(e.target.value)} />
                        </div>
                    </div>
                    <div className='form-row'>
                        <div className='inpt-row'>
                            <label>Discount (in percentage)</label>
                            <input type='number' value={discount} onChange={(e) => setDiscount(e.target.value)} />
                        </div>
                        <div className='inpt-row'>
                            <label>Timing (in minutes)</label>
                            <input type='number' value={timing} onChange={(e) => setTiming(e.target.value)} />
                        </div>
                    </div>
                    <div className='form-row'>
                        <div className='inpt-row'>
                            <label>Category</label>
                            <select name='categoryId' value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
                                <option>Select Category</option>
                                {categoryList}
                            </select>
                        </div>
                        <div className='inpt-row'>
                            <label>UPLOAD PHOTO</label>
                            <input type='file' ref={inputFile} onChange={(e) => setFile(e.target.files[0])} />
                        </div>
                    </div>
                    <Button type='submit' variant="contained" disableElevation>
                        {loading ? <BiLoader size={24} className='animate-spin' /> : "Add Category"}
                    </Button>
                </form>
            </div>
        </div>

    )
}
